webpackJsonp([177890977751730],{

/***/ 222:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(17);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _banner = __webpack_require__(46);
	
	var _banner2 = _interopRequireDefault(_banner);
	
	var _sectionTitle = __webpack_require__(14);
	
	var _sectionTitle2 = _interopRequireDefault(_sectionTitle);
	
	var _button = __webpack_require__(29);
	
	var _button2 = _interopRequireDefault(_button);
	
	var _accident_illness_policy = __webpack_require__(323);
	
	var _accident_illness_policy2 = _interopRequireDefault(_accident_illness_policy);
	
	var _allegations_of_abuse = __webpack_require__(324);
	
	var _allegations_of_abuse2 = _interopRequireDefault(_allegations_of_abuse);
	
	var _behaviour_management = __webpack_require__(325);
	
	var _behaviour_management2 = _interopRequireDefault(_behaviour_management);
	
	var _complaints_policy = __webpack_require__(326);
	
	var _complaints_policy2 = _interopRequireDefault(_complaints_policy);
	
	var _confidentiality_policy = __webpack_require__(327);
	
	var _confidentiality_policy2 = _interopRequireDefault(_confidentiality_policy);
	
	var _emergency_plan = __webpack_require__(328);
	
	var _emergency_plan2 = _interopRequireDefault(_emergency_plan);
	
	var _eyfs_parent_guide_user_guide = __webpack_require__(330);
	
	var _eyfs_parent_guide_user_guide2 = _interopRequireDefault(_eyfs_parent_guide_user_guide);
	
	var _eyfs_parent_guide = __webpack_require__(329);
	
	var _eyfs_parent_guide2 = _interopRequireDefault(_eyfs_parent_guide);
	
	var _health_safety = __webpack_require__(331);
	
	var _health_safety2 = _interopRequireDefault(_health_safety);
	
	var _healthy_eating = __webpack_require__(332);
	
	var _healthy_eating2 = _interopRequireDefault(_healthy_eating);
	
	var _inclusion = __webpack_require__(333);
	
	var _inclusion2 = _interopRequireDefault(_inclusion);
	
	var _lost_child = __webpack_require__(334);
	
	var _lost_child2 = _interopRequireDefault(_lost_child);
	
	var _medicine = __webpack_require__(335);
	
	var _medicine2 = _interopRequireDefault(_medicine);
	
	var _non_collection_of_child = __webpack_require__(336);
	
	var _non_collection_of_child2 = _interopRequireDefault(_non_collection_of_child);
	
	var _risk_assessment = __webpack_require__(337);
	
	var _risk_assessment2 = _interopRequireDefault(_risk_assessment);
	
	var _safeguarding_children = __webpack_require__(338);
	
	var _safeguarding_children2 = _interopRequireDefault(_safeguarding_children);
	
	var _working_in_partnership_with_parents = __webpack_require__(339);
	
	var _working_in_partnership_with_parents2 = _interopRequireDefault(_working_in_partnership_with_parents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Policy = function Policy() {
		return _react2.default.createElement(
			'div',
			{ className: 'policy' },
			_react2.default.createElement(_banner2.default, { type: 'policy', title: 'Our Policies' }),
			_react2.default.createElement(
				'section',
				{ className: 'page-grid' },
				_react2.default.createElement(
					'section',
					{ className: 'page-grid-section first' },
					_react2.default.createElement(
						'div',
						{ className: 'container' },
						_react2.default.createElement(
							'div',
							{ className: 'rc-copy' },
							'Here is a list of my childcare contract and policies:'
						),
						_react2.default.createElement('br', null),
						_react2.default.createElement('br', null),
						_react2.default.createElement(
							'div',
							{ className: 'policy-block' },
							_react2.default.createElement(_sectionTitle2.default, { title: 'Accident Illness Policy' }),
							_react2.default.createElement(_button2.default, { text: 'View', action: 'true', link: _accident_illness_policy2.default, target: 'blank' })
						),
						_react2.default.createElement(
							'div',
							{ className: 'policy-block' },
							_react2.default.createElement(_sectionTitle2.default, { title: 'allegations of abuse' }),
							_react2.default.createElement(_button2.default, { text: 'View', action: 'true', link: _allegations_of_abuse2.default, target: 'blank' })
						),
						_react2.default.createElement(
							'div',
							{ className: 'policy-block' },
							_react2.default.createElement(_sectionTitle2.default, { title: 'Behaviour Management Policy' }),
							_react2.default.createElement(_button2.default, { text: 'View', action: 'true', link: _behaviour_management2.default, target: 'blank' })
						),
						_react2.default.createElement(
							'div',
							{ className: 'policy-block' },
							_react2.default.createElement(_sectionTitle2.default, { title: 'Complaints Policy' }),
							_react2.default.createElement(_button2.default, { text: 'View', action: 'true', link: _complaints_policy2.default, target: 'blank' })
						),
						_react2.default.createElement(
							'div',
							{ className: 'policy-block' },
							_react2.default.createElement(_sectionTitle2.default, { title: 'Confidentiality Policy' }),
							_react2.default.createElement(_button2.default, { text: 'View', action: 'true', link: _confidentiality_policy2.default, target: 'blank' })
						),
						_react2.default.createElement(
							'div',
							{ className: 'policy-block' },
							_react2.default.createElement(_sectionTitle2.default, { title: 'Emergency Plan Policy' }),
							_react2.default.createElement(_button2.default, { text: 'View', action: 'true', link: _emergency_plan2.default, target: 'blank' })
						),
						_react2.default.createElement(
							'div',
							{ className: 'policy-block' },
							_react2.default.createElement(_sectionTitle2.default, { title: 'EYFS Parent Guide - User Guide' }),
							_react2.default.createElement(_button2.default, { text: 'View', action: 'true', link: _eyfs_parent_guide_user_guide2.default, target: 'blank' })
						),
						_react2.default.createElement(
							'div',
							{ className: 'policy-block' },
							_react2.default.createElement(_sectionTitle2.default, { title: 'EYFS Parent Guide' }),
							_react2.default.createElement(_button2.default, { text: 'View', action: 'true', link: _eyfs_parent_guide2.default, target: 'blank' })
						),
						_react2.default.createElement(
							'div',
							{ className: 'policy-block' },
							_react2.default.createElement(_sectionTitle2.default, { title: 'Health & Safety Policy' }),
							_react2.default.createElement(_button2.default, { text: 'View', action: 'true', link: _health_safety2.default, target: 'blank' })
						),
						_react2.default.createElement(
							'div',
							{ className: 'policy-block' },
							_react2.default.createElement(_sectionTitle2.default, { title: 'Healthy Eating Policy' }),
							_react2.default.createElement(_button2.default, { text: 'View', action: 'true', link: _healthy_eating2.default, target: 'blank' })
						),
						_react2.default.createElement(
							'div',
							{ className: 'policy-block' },
							_react2.default.createElement(_sectionTitle2.default, { title: 'Inclusion Policy' }),
							_react2.default.createElement(_button2.default, { text: 'View', action: 'true', link: _inclusion2.default, target: 'blank' })
						),
						_react2.default.createElement(
							'div',
							{ className: 'policy-block' },
							_react2.default.createElement(_sectionTitle2.default, { title: 'Lost Child Policy' }),
							_react2.default.createElement(_button2.default, { text: 'View', action: 'true', link: _lost_child2.default, target: 'blank' })
						),
						_react2.default.createElement(
							'div',
							{ className: 'policy-block' },
							_react2.default.createElement(_sectionTitle2.default, { title: 'Medicine Policy' }),
							_react2.default.createElement(_button2.default, { text: 'View', action: 'true', link: _medicine2.default, target: 'blank' })
						),
						_react2.default.createElement(
							'div',
							{ className: 'policy-block' },
							_react2.default.createElement(_sectionTitle2.default, { title: 'Non Collection of Child Policy' }),
							_react2.default.createElement(_button2.default, { text: 'View', action: 'true', link: _non_collection_of_child2.default, target: 'blank' })
						),
						_react2.default.createElement(
							'div',
							{ className: 'policy-block' },
							_react2.default.createElement(_sectionTitle2.default, { title: 'Risk Assessment Policy' }),
							_react2.default.createElement(_button2.default, { text: 'View', action: 'true', link: _risk_assessment2.default, target: 'blank' })
						),
						_react2.default.createElement(
							'div',
							{ className: 'policy-block' },
							_react2.default.createElement(_sectionTitle2.default, { title: 'Safeguarding Children Policy' }),
							_react2.default.createElement(_button2.default, { text: 'View', action: 'true', link: _safeguarding_children2.default, target: 'blank' })
						),
						_react2.default.createElement(
							'div',
							{ className: 'policy-block' },
							_react2.default.createElement(_sectionTitle2.default, { title: 'Working In Partnership With Parents Policy' }),
							_react2.default.createElement(_button2.default, { text: 'View', action: 'true', link: _working_in_partnership_with_parents2.default, target: 'blank' })
						)
					)
				)
			)
		);
	};
	
	exports.default = Policy;
	module.exports = exports['default'];

/***/ }),

/***/ 323:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/accident_illness_policy.e6b71524.pdf";

/***/ }),

/***/ 324:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/allegations_of_abuse.cb46a4f5.pdf";

/***/ }),

/***/ 325:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/behaviour_management.e4cd689e.pdf";

/***/ }),

/***/ 326:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/complaints_policy.e66809d2.pdf";

/***/ }),

/***/ 327:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/confidentiality_policy.82d354e5.pdf";

/***/ }),

/***/ 328:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/emergency_plan.87addd30.pdf";

/***/ }),

/***/ 329:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/eyfs_parent_guide.075a6db4.pdf";

/***/ }),

/***/ 330:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/eyfs_parent_guide_user_guide.2b66159e.pdf";

/***/ }),

/***/ 331:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/health_safety.d451ac1d.pdf";

/***/ }),

/***/ 332:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/healthy_eating.5828f8c7.pdf";

/***/ }),

/***/ 333:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/inclusion.6737ad06.pdf";

/***/ }),

/***/ 334:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/lost_child.38454960.pdf";

/***/ }),

/***/ 335:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/medicine.b399bffe.pdf";

/***/ }),

/***/ 336:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/non_collection_of_child.ef71b45c.pdf";

/***/ }),

/***/ 337:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/risk_assessment.90b8170b.pdf";

/***/ }),

/***/ 338:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/safeguarding_children.bbd6e099.pdf";

/***/ }),

/***/ 339:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/working_in_partnership_with_parents.4aa32a84.pdf";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-policy-js-3cfd4f5eb4b76357c870.js